import type { Website } from "@/constants/features";
import * as api from "../client";

/**
 * Per-website-edition office availability for a firm, mirroring the staff-bff
 * `GET /api/v1/address-book/office-availability` response. Each flag is `true`
 * when the firm has at least one qualifying office for that edition (any office
 * for the legal500.com editions; a France / Germany office for fr / de).
 */
export type OfficeAvailability = Record<Website, boolean>;

type OfficeAvailabilityResponse = {
  office_availability: OfficeAvailability;
  request_id: string;
};

const BASE = "/v1/address-book/office-availability";

export const officeAvailabilityService = {
  /**
   * Cross-firm lookup: staff pass the target profile's `companyId` explicitly
   * (there is no actor firm scope on staff-bff).
   */
  async getByCompanyId(companyId: string): Promise<OfficeAvailability> {
    const raw = await api.get<OfficeAvailabilityResponse>(
      `${BASE}?companyId=${encodeURIComponent(companyId)}`,
    );
    return raw.office_availability;
  },
};
